/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Function to open and close interest list on collection pages
function toggleFilterList() {
	var filterListTitle = document.querySelector("#filter-list-title");
	var filterList = document.querySelector("#filter-list");
	var interestList = document.querySelector("#interest-list");

	let classes = filterList.classList;
	if (classes.contains('hidden')) {
		filterList.classList.remove('hidden');
		filterList.classList.add('shown');
		interestList.classList.add('hidden');
		interestList.classList.remove('shown');

	} else {
		filterList.classList.add('hidden')
		filterList.classList.remove('shown');
		interestList.classList.add('shown');
		interestList.classList.remove('hidden');
	}
}

// Function to open and close interest list on collection pages
function toggleInterestList() {
	var interestListTitle = document.querySelector("#interest-list-title");
	var interestList = document.querySelector("#interest-list");
	var filterList = document.querySelector("#filter-list");

	let classes = interestList.classList;
	if (classes.contains('hidden')) {
		interestList.classList.remove('hidden');
		interestList.classList.add('shown');
		filterList.classList.add('hidden');
		filterList.classList.remove('shown');
	} else {
		interestList.classList.add('hidden')
		interestList.classList.remove('shown');
		filterList.classList.add('shown');
		filterList.classList.remove('hidden');

	}
}

// filter search results by tag, split on ','
function filterBy(e, tag) {
	e.preventDefault();
	let path = (location.pathname + location.search).substr(1);
	let prefix = path.split(',')[ 0 ];
	let parent = e.target.parentElement;

	parent.classList.forEach((c) => {
		if (c == 'js-active') {
			window.location = prefix;
		} else {
			if (!path.includes(',')) {
				var res = path.concat(',' + tag);

				window.location = res;
			} else {
				var res = prefix + ',' + tag
				window.location = res;
			}
		}
	});
}

// Function to toggle the size guide accordion on PDP
function toggleSizeGuide(productHandle) {
	if (window.location.href.includes("products")) {
		if ($('#acc-1').hasClass('js-active')) {
			//   	$('.product-single__accordion')[0].scrollIntoView({behavior: "smooth"});
			$('html').stop().animate({
				'scrollTop': $('#acc-1').offset().top - 120
			}, 900, 'swing', function () {
				window.location.hash = '#acc-1';
			});
		} else {
			$('#acc-1').addClass('js-active').removeAttr('style');
			$('.product-single__accordion')[ 0 ].scrollIntoView({ behavior: "smooth" });
		}
	} else {
		window.location.href = `/products/${productHandle}?size-guide=true`

	}
}

// Gift wrap form handler
// Listen if gift wrap checkbox is clicked
$('#gift-wrap-checkbox').on('click', function () {
	if ($('#gift-wrap-checkbox').is(':checked')) {
		// if checked display the form container
		$('.gift-wrap-container').css('display', 'block');
	} else {
		// otherwise hide container
		$('.gift-wrap-container').css('display', 'none');
	}
});

// Force mobileDraw on nav items to avoid original menu showing intermittently
var mobileDraw = $(".js-mobile-draw-icon");
var searchDraw = $(".js-search-draw-icon");
var cartDraw = $(".js-cart-draw-icon");
var primaryNav = $(".js-primary-nav");
var secondaryNav = $(".js-secondary-nav");

function updateHeaderNav() {
	$(".js-header").removeClass('header--inline-icons');
	mobileDraw.show();
	searchDraw.show();
	cartDraw.show();
	primaryNav.hide();
	secondaryNav.hide();
}

updateHeaderNav();

// Add to Cart handler for gift wrap
$('.js-product-add').on('click', function (e) {
	if ($('#gift-wrap-checkbox').is(':checked')) {
		e.preventDefault();

		let color = $('#gift-wrap-select option:selected').text();

		let formData = {
			'items': [ {
				'id': $('#productSelect-1 option:selected').val(),
				'quantity': 1
			},
			{
				'id': color == 'Gold' ? 31051468603415 : 31051468636183,
				'quantity': 1,
				'properties': {
					'Gift Message': $('#gift-message').val(),
					'Gift Wrap Color': color,
					'Gift Wrap Product': $('#productSelect-1 option:selected').attr('data-sku')
				}
			} ]
		}

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
			.then(response => {
				jQuery.post('/cart/update.js', {
					note: 'Gift Wrap - Color: ' + color + ' | Message: ' + $('#gift-message').val() + ' | product: ' + $('#productSelect-1 option:selected').attr('data-sku')
				});

				//       window.location = '/cart';
			})
			.catch((error) => {
				console.log('Error: ', error);
			});
	}
});